import * as React from "react";
import { TypeCell, NodeCell, ThroughputCell, ExpandedSectionToggleWrapper } from "components/inputs/InputsOveriew";
import FailuresCell from "components/inputs/InputsOveriew/cells/FailuresCell";
import { InputStateBadge } from "components/inputs";
import Routes from "routing/Routes";
import { Link } from "components/common";
const customColumnRenderers = ({ inputTypes, inputStates }) => ({
  attributes: {
    title: {
      renderCell: (_title, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.INPUT_DIAGNOSIS(input.id), title: `show input diagnosis for ${input.title}` }, input.title)),
      width: 0.5
    },
    type: {
      renderCell: (type, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(TypeCell, { type, inputTypes })),
      width: 0.5
    },
    desired_state: {
      renderCell: (_state, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(InputStateBadge, { input, inputStates })),
      staticWidth: 130
    },
    node_id: {
      renderCell: (_type, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(NodeCell, { input })),
      staticWidth: 150
    },
    traffic: {
      renderCell: (_traffic, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(ThroughputCell, { input })),
      staticWidth: 180
    },
    input_failures: {
      renderCell: (_failures, input) => /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, /* @__PURE__ */ React.createElement(FailuresCell, { input })),
      staticWidth: 130
    },
    address: {
      renderCell: (_address, input) => {
        var _a;
        return /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, ((_a = input.attributes) == null ? void 0 : _a.bind_address) || "N/A");
      },
      staticWidth: 125
    },
    port: {
      renderCell: (_port, input) => {
        var _a;
        return /* @__PURE__ */ React.createElement(ExpandedSectionToggleWrapper, { id: input.id }, ((_a = input.attributes) == null ? void 0 : _a.port) || "N/A");
      },
      staticWidth: "matchHeader"
    }
  }
});
export default customColumnRenderers;
